import {changeEvent, clickEvent, customEvent, documentLoadEvent} from "../../../webpack/modules/events";
import {
    addToCart, addToCartMultiSize, hideLoaderAddToCartButton,
    showLoaderAddToCartButton
} from "../../../webpack/modules-optimized/product-page";
import {initRecommender} from "../../../webpack/modules-optimized/product-page-recommender-bridge";
import {addLastViewedProduct} from "../../../webpack/modules-optimized/last-viewed-products";
import {getOptions, isMultiSizeProduct, trackProductPageGa4Events} from "../../../webpack/modules-optimized/product";
import {onVisible} from "../../../scripts/Tools/visible-element-observer";
import {toggleDescriptionVisibility, updateVisibilityDescription} from "../../../webpack/modules/description";
import {hideModal, showModal} from "../../../webpack/modules-optimized/modal";
import {ga4TrackSimpleEvent, getClientId, getUserId, getAttributionToken} from "../../../webpack/modules/analytics";
import {hideOffcanvasByDomObject, showOffcanvas} from "../../../webpack/modules-optimized/offcanvas";
import {addItem, openCart, updateItemsNumber} from "../../../webpack/modules-optimized/cart";
import {post} from "../../../webpack/modules/ajax";
import {getWishListItems, updateWishListButton} from "../../../webpack/modules-optimized/wishlist";
import {dispatchCustomEvent} from "../../../webpack/modules/events";

const botPatternG = "(spider|crawler|claude|perplexity|anthropic|gpt|open-ai|googlebot|google-?(bot|extended|cloudvertexbot|read-aloud|site-verification|inspectiontool|other|image)|adsbot-google|apis-google|feedfetcher-google|mediapartners-google|storebot-google|duplexweb-google|google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
const reG = new RegExp(botPatternG,"i");
const userAgentG = navigator.userAgent;
const isEmptyUA = !userAgentG || userAgentG.trim() === "";
const is_crawlerG = reG.test(userAgentG) || navigator.webdriver || isEmptyUA;

documentLoadEvent(function() {
    let richCard = document.querySelector('script[type="application/ld+json"]');
    let productType = '-';

    if (richCard) {
        let jsonld = JSON.parse(richCard.innerText);
        productType = (jsonld ? jsonld.category || '' : '').toLowerCase();
    }

    onVisible(document.querySelectorAll('main.product .recommenders'), getRecommenders, 0.2);
    //onVisible(document.querySelectorAll('main.product .recommender'), (recommender) => initRecommender(recommender, productType), 0.2);
    addLastViewedProduct(document.querySelector('#reference').value);
    onVisible(document.querySelectorAll(".offcanvas img"), function (image) {if (image.dataset.src) image.src = image.dataset.src;});
    fillWishListButton();

    if (!is_crawlerG) {
        try {
            // Send detail-page-view event to Retail
            dataLayer.push({
                cloud_retail: {
                    searchQuery: null,
                    purchaseTransaction: null,
                    productDetails: null
                }
            });
            const token = getAttributionToken();
            const visitorId = getClientId();
            const userId = getUserId();
            const locale = document.documentElement.lang.replace('-', '_');
            const productId = document.getElementById("reference").value+'-'+locale;
            let retailPayload = {
                eventType: "detail-page-view",
                visitorId: visitorId,
                productDetails: [{
                    product: {
                        id: productId
                    }
                }]
            };
            if (userId && userId !== "null" && userId !== "undefined" && userId.trim() !== "") {
                retailPayload.userInfo = { userId: userId };
            }
            if (token && token.trim() !== "") {
                retailPayload.attributionToken = token;
            }

            dataLayer.push({
                event: "retail_detail_page_view",
                cloud_retail: retailPayload
            });
        } catch (error) {
            // Nothing to do, if dataLayer or any variable is not defined, we just skip the event tracking
        }
    }
});

clickEvent('#product-page .open-popup-premium', false, function(element) {
    showModal('modal-user-premium');
});

clickEvent('#modal-user-premium .add-premium-to-cart', true, async function(element) {
    await addItem({'productId': element.dataset.id, 'quantity': 1, 'isLocked': true});
    hideModal('modal-user-premium');

    openCart();
    updateItemsNumber(true);
});

customEvent('show.bs.offcanvas', '#product-page .options:not(.options-section)', false, function(element) {
    trackProductPageGa4Events('OpenProductOffCanvas', 'selector_' + (element.dataset.type || '').toLowerCase());
});

customEvent('show.bs.offcanvas', '#product-page #reviews', false, function() {
    trackProductPageGa4Events('OpenProductOffCanvas', 'reviews');
});

customEvent('shown.bs.collapse', '#product-page #offcanvas-product-information .collapse', false, function(element) {
    trackProductPageGa4Events('ProductInformation', 'info_' + (item.dataset.type || '').toLowerCase());
});

clickEvent('#product-page .toggle-product-description .toggle-button', false, function (element) {
    let description = element.closest('.toggle-product-description').querySelector('.description');
    let icon = element.querySelector('i');
    if (description.classList.contains('description-closed')) {
        description.classList.remove('description-closed');
        icon.classList.remove('fa-plus');
        icon.classList.add('fa-minus');
        setTimeout(() => {description.style.maxHeight = description.scrollHeight+'px'}, 500);
    } else {
        description.classList.add('description-closed');
        icon.classList.remove('fa-minus');
        icon.classList.add('fa-plus');
        description.style.maxHeight = '';
    }
});

clickEvent('#product-page .open-product-information', false, function(element) {

    let buttonDescription = element.querySelector('.button-description');
    let description = document.querySelector('#product-page #offcanvas-product-information .description');

    if (description.textContent.trim() === '') {
        description.innerHTML = buttonDescription.innerHTML;
        updateVisibilityDescription([description]);
        setTimeout(() => {showOffcanvas('offcanvas-product-information')}, 200);
    } else {
        showOffcanvas('offcanvas-product-information');
    }
});

changeEvent('#product-page .product-complements', false, function(element) {
    let name = element.dataset.name || '-';
    let type = element.dataset.type || '-';

    if (name !== '-' && type !== '-') {
        if (element.checked) {
            if (type === 'sample_image') trackProductPageGa4Events('SampleImage', name);
            else trackProductPageGa4Events('Complement', name);
        } else {
            if (type === 'sample_image') trackProductPageGa4Events('SampleImage', name);
            else trackProductPageGa4Events('ComplementUnselect', name);
        }
    }
});

changeEvent('#product-page .product-cross-selling', false, function(element) {
    let name = element.dataset.name || '-';

    if (name !== '-') {
        if (element.checked) {
            if (element.checked) trackProductPageGa4Events('CrossSelling', name);
        } else {
            if (element.checked) trackProductPageGa4Events('CrossSellingUnselect', name);
        }
    }
});

clickEvent('#product-page .btn-add-to-cart', false, function(element) {
    let container = element.closest('.product-scope');

    if (isMultiSizeProduct(container)) addToCartMultiSize(container);
    else addToCart(container);
});

clickEvent('#product-page .description-container .change-description-visibility', false, function(button) {
    toggleDescriptionVisibility(button.closest('.description-container'));
});

clickEvent('#product-page .btn-add-to-cart-sample-product', false, async function(button) {
    let offcanvas = button.closest('.offcanvas');
    let productAssociatedOptions = getOptions(document.querySelector('#product-page'));

    showLoaderAddToCartButton(button);

    let data = {};
    data['productId'] = button.dataset.productId;
    data['quantity'] = 1;
    data['isLocked'] = true;
    data['options'] = {};
    data['options']['width'] = button.dataset.width;
    data['options']['height'] = button.dataset.height;
    data['options']['device'] = button.dataset.device;
    data['options']['composition'] = button.dataset.composition;
    data['options']['associatedProduct'] = button.dataset.associatedProduct;
    if (productAssociatedOptions['color']) data['options']['color'] = productAssociatedOptions['color'];

    await addItem(data);
    if (offcanvas) hideOffcanvasByDomObject(offcanvas);
    openCart();
    updateItemsNumber(true);
    hideLoaderAddToCartButton(button);
    ga4TrackSimpleEvent({event: 'sample_product', method: 'add_to_cart'});
});


function getRecommenders()
{
    post(
        '/ajax/website/product/get-recommenders',
        {
            reference: document.querySelector('#reference').value,
        },
        function (response) {
            if (response.done) {
                let container = document.getElementById('recommenders-block');
                if (container) {
                    container.innerHTML = response.view;
                    let richCard = document.querySelector('script[type="application/ld+json"]');
                    let productType = '-';

                    if (richCard) {
                        let jsonld = JSON.parse(richCard.innerText);
                        productType = (jsonld ? jsonld.category || '' : '').toLowerCase();
                    }

                    document.querySelectorAll('main.product .recommender').forEach((recommender) => {
                        initRecommender(recommender, productType);
                    });
                    dispatchCustomEvent('productRecommendersRendered', {container: container});
                }
            }
        },
    );
}

async function fillWishListButton()
{
    let wishListItems = await getWishListItems();

    document.querySelectorAll('#product-page .add-item-wish-list').forEach(function(button) {
        if (wishListItems && wishListItems.includes(parseInt(button.dataset.productId))) updateWishListButton(button, true);
    });
}